
    import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
    import { mapActions, mapMutations, mapState } from 'vuex';
    import Patient from '@/types/Patient';
    import { CardInfo } from '@/types/soap/elga/Card';

    @Component({
        computed: {
            ...mapState('globals', ['formatDate']),
            ...mapState('patient', ['loaders', 'cardInfo', 'cardInfoPatienten']),
        },
        methods: {
            ...mapActions('patient', ['loadPatient', 'findImpfpass', 'syncImpfpass']),
            ...mapMutations('patient', ['patientNew']),
        },
    })
    export default class PatientCardInfoDialog extends Vue {
        @Prop() visible!: boolean;
        @Prop() value!: Patient;

        public patientData = new Patient();
        public curIndex = 0;
        public syncImpfpass!: (patient: Patient) => void;
        public findImpfpass!: (patient: Patient) => void;

        public cardInfo!: CardInfo;
        public cardInfoPatienten!: Patient[];
        public loadPatient!: (payload: { patnr: number }) => Promise<void>;
        public patientNew!: (visible: boolean) => void;

        @Watch('visible')
        public onChangeVisible(visible: boolean): void {
            if (visible) {
                this.curIndex = 0;
            }
        }

        public get patient(): Patient {
            return this.cardInfoPatienten[this.curIndex] ?? new Patient();
        }

        public onClickCancel(): void {
            this.loadPatient({patnr: this.patient.patnr as number});
            this.$emit('close');
        }
    }
